import React, { Fragment } from 'react';
import PropTypes from  'prop-types';
import  { withStyles } from  '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import Qualifiers from './Qualifiers';


function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const styles = theme => ({
  root: {
    flexGrow: 1, 
    //minHeight: 400,
  // padding: theme.spacing.unit * 1,
  },
  tabsRoot: {
    marginBottom: theme.spacing.unit * 1,
   // borderBottom: '1px solid #e8e8e8',
  },
  tabsIndicator: {
    backgroundColor: '#1F2833',
  },
  tabRoot: {
    border: '1px solid #C5C6C7',
    textTransform: 'initial',
    fontWeight: 'bold',
    marginRight: theme.spacing.unit * 4,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#0B0C10',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#0B0C10',
      fontWeight: 'bold',
      backgroundColor:'#00FEE6',
      border: '0px solid #C5C6C7',
    },
    '&:focus': {
      color: '#0B0C10',
    },
  },
  tabSelected: {},
});

@inject("commonStore")
@observer
class LeadTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        value: 0,
    }
  }
  makeTabs = () => {
    console.log('makeTabs')
    const { classes, leadTypes } = this.props
    console.log(leadTypes)
    return leadTypes.map(leadType => {
        return (<Tab
        key={leadType}
        disableRipple
        classes={{ root: classes.tabRoot, selected: classes.tabSelected, disabled:classes.tabDisabled }}
        label={jsUcfirst(leadType)}
      />)
    })
  }
  makeTabBody = (value) => {
    const { classes, commonStore, leadTypes, ...otherProps } = this.props;
    
    if(value < leadTypes.length){
      const leadType = leadTypes[value]
      return (
          <Fragment>
          <Qualifiers leadType={leadType} {...otherProps} />
        </Fragment>
        )
    }
    return null
  }

  handleTabChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { value } = this.state
    const { classes } = this.props
    return (
      <div className={classes.root}>
            <Tabs
              value={value}
              onChange={this.handleTabChange}
              classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
              >
                   {this.makeTabs()}
            </Tabs>
            {this.makeTabBody(value)}
        </div>
    );
  }
}

LeadTypes.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LeadTypes);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Tiered/LeadTypes.js